import { render, staticRenderFns } from "./primaryButton.vue?vue&type=template&id=0049a8e0"
import script from "./primaryButton.vue?vue&type=script&lang=js"
export * from "./primaryButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports